import { Component } from 'nospa';

const ACTIVE_THUMB_CLASSNAME = '_active';

export default class ProductGallery extends Component {
  onInit() {
    this.onClickThumb = this.onClickThumb.bind(this);

    this.viewRef = this.$getRef('view');
    this.activeThumbRef = this.$getRefs('thumb')
      .find(({ el }) => el.classList.contains(ACTIVE_THUMB_CLASSNAME));

    this.$onRef('thumb', 'click', this.onClickThumb);
  }

  onClickThumb(e, ref) {
    if (ref.el === this.activeThumbRef.el) return;

    this.activeThumbRef.el.classList.remove(ACTIVE_THUMB_CLASSNAME);

    this.activeThumbRef = ref;
    ref.el.classList.add(ACTIVE_THUMB_CLASSNAME);

    const { src, webp } = ref.props;

    const source = webp ? `<source srcset="${webp}" type="image/webp">` : '';
    const img = `<img src="${src}">`;

    this.viewRef.el.innerHTML = `<picture>${source}${img}</picture>`;
  }

  onDestroy() {
    this.$offRef('thumb', 'click', this.onClickThumb);
  }
}
